
    <!--
 * 竖版-页面导航
 * @LastEditTime: Tue Dec 17 2024 15:43:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_0MJ127"  v-show="compData.isShow" :class="[`normal`,`u_c_0MJ127`]" ><div id="u_c_ZAKX28"  v-for="(btnItem, btnI) in compData.btnList" :key="btnI" :class="[`normal`,`u_c_ZAKX28`]" ><a id="u_c_EOAU29" href="javascript:;" :style="`${ btnItem.pic ? `background-image:url(${ btnItem.pic })` : '' }`" :class="[`${ btnItem.cur ? 'cur' : '' }`,`normal btn-light`,`u_c_EOAU29`]" @click="u_c_EOAU29_event_F9W931($event,btnI,btnItem.block,btnItem.link)"><div id="u_c_3GCD30"  v-html="pageData.isEdit ? btnItem.text : getBtnText(btnItem)" :class="[`normal`,`u_c_3GCD30`]" ></div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"组队邀请"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"前往充值"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"完成任务"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"抽取豪礼"},{"pic":"","block":"download","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"下载游戏"}],"isShow":true},"zh-CN":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"邀请战友"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"立即储值"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"完成任务"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"抽取豪礼"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"下载游戏"}],"isShow":true},"zh-TW":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"邀請戰友"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"立即儲值"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"完成任務"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"抽取豪禮"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"下載遊戲"}],"isShow":true},"en-US":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Invite Friends"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Top Up"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Complete Quests"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Draw Rewards"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Download Now"}],"isShow":true},"ja-JP":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"友達招待"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"チャージへ"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"任務完了"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"豪華報酬抽選"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"ゲームダウンロード"}],"isShow":true},"ko-KR":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"전우 초대"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"충전하기"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"임무 완료"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"호화 선물 뽑기"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"게임 다운로드"}],"isShow":true},"th-TH":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"เชิญเพื่อน"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"เติมเงิน"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"เคลียร์ภารกิจ"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"จับรางวัลใหญ่"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"ดาวน์โหลดเกม"}],"isShow":true},"vi-VN":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Mời Chiến Hữu"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Nạp ngay"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Hoàn Thành Nhiệm Vụ"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Quay Quà"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Tải Trò Chơi"}],"isShow":true},"de-DE":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Lade Freunde ein"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Aufladen"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Quests abschließen"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Ziehungs-Belohnungen"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Jetzt herunterladen"}],"isShow":true},"fr-FR":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Inviter des amis"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recharger"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Terminer les Quêtes"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Récompenses de Tirage"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Télécharger maintenant"}],"isShow":true},"ru-RU":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Приглашение друзей"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Пополнить"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Завершите задания"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Награды розыгрыша"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Скачайте сейчас"}],"isShow":true},"es-ES":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Invitar amigos"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recargar"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Completar misiones"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Sortear recompensas"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Descargar ahora"}],"isShow":true},"pt-PT":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Convide amigos"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recarregar"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Missões Completas"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Sorteio de Recompensas"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Baixar Agora"}],"isShow":true},"it-IT":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Invita Amici"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Ricarica"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Completa Missioni"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Pesca Ricompense"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Scarica Ora"}],"isShow":true},"tr-TR":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Arkadaşlarını Davet Et"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Yükle"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Görevleri Tamamla"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Ödül Çek"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Şimdi İndir"}],"isShow":true},"pl-PL":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Zaproś znajomych"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Doładowanie"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Ukończ zadania"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Nagrody losowane"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Pobierz teraz"}],"isShow":true},"id-ID":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Undang Teman"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Segera Top Up"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Selesaikan Misi"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Undi Hadiah Mewah"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"Unduh Game"}],"isShow":true},"ar-SA":{"btnList":[{"pic":"","block":"u_c_XTM149","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"قم بدعوة الرفاق"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"اشحن الآن"},{"pic":"","block":"u_c_DIDC46","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"أكمِل المهام"},{"pic":"","block":"u_c_6FRM32","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"اسحب أروع الهدايا"},{"pic":"","block":"download","link":"https://pns.onelink.me/6tpA/klslibxm","text":"حمّل اللعبة"}],"isShow":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '页面导航';

    // 自定义setup - 开始
    const getCurLink = inject("getCurLink", (link) => {})

const init = () => {
  compData.isShow = true;
  if (bridge.runInsdk()) {
    compData.btnList = compData.btnList.filter((item) => {
      return item.block != "pay";
    });
  }
  compData.btnList.forEach((item) => {
    if (item.link) {
      item.link = getCurLink(item.link)
    }
  })
}

init()

// 获取按钮名称
const getBtnText = (item) => {
  if (item.block === "pay") {
    return getLangTxt("goPay");
  }
  if (item.block === "download") {
    return getLangTxt("downloadGame");
  }
  return item.text;
};
let sectionPosition = []
onMounted(() => {
  let curScroll = document.documentElement.scrollTop
  compData.btnList.forEach((item, index) => {
    if (item.block && !["pay", "download"].includes(item.block)) {
      let _ele = document.getElementById(item.block)
      if (_ele) {
        let _p = _ele.getBoundingClientRect()
        sectionPosition.push({
          top: Math.floor(_p.top + curScroll + _p.height / 3),
          realTop: Math.floor(_p.top + curScroll),
          index,
        })
      }
    }
  })
  const throttledFn = vueUse.useThrottleFn(() => {
    let curScroll = document.documentElement.scrollTop
    let curIndex = sectionPosition.findIndex((item) => item.top > curScroll)
    if (~curIndex) {
      compData.btnList.forEach((item, index) => {
        if (index == sectionPosition[curIndex].index) {
          item.cur = 1
        } else {
          item.cur = 0
        }
      })
    }
  })
  window.addEventListener("scroll", throttledFn)
  throttledFn()
});
      // 自定义元素1EOAU29的click事件
      const u_c_EOAU29_event_F9W931= async (e,index,block,link)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `导航栏-${index}`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})

if (!block || ["pay", "download"].includes(block)) {
  if (block === "pay") {
    bridge.open(pageData.storeLink);
    return;
  }
  bridge.open(link)
} else {
  let curTopIndex = sectionPosition.findIndex(
    (item) => item.index == index
  )
  if (~curTopIndex) {
    window.scrollTo({
      top: sectionPosition[curTopIndex].realTop,
      behavior: "smooth",
    })
  }
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.default{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.default{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.default{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.zh-CN{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.zh-CN{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.zh-CN{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.zh-CN{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.zh-TW{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.zh-TW{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.zh-TW{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.zh-TW{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.en-US{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.en-US{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.en-US{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.en-US{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ja-JP{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.ja-JP{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.ja-JP{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.ja-JP{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ko-KR{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.ko-KR{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.ko-KR{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.ko-KR{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.th-TH{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.th-TH{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.th-TH{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.th-TH{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.vi-VN{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.vi-VN{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.vi-VN{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.vi-VN{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.de-DE{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.de-DE{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.de-DE{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.de-DE{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.fr-FR{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.fr-FR{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.fr-FR{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.fr-FR{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ru-RU{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.ru-RU{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.ru-RU{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.ru-RU{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.es-ES{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.es-ES{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.es-ES{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.es-ES{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.pt-PT{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.pt-PT{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.pt-PT{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.pt-PT{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.it-IT{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.it-IT{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.it-IT{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.it-IT{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.tr-TR{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.tr-TR{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.tr-TR{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.tr-TR{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.pl-PL{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.pl-PL{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.pl-PL{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.pl-PL{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.id-ID{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.id-ID{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.id-ID{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.id-ID{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ar-SA{
.u_c_0MJ127.normal{
position:fixed;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
width:10.00rem;

}
}.ar-SA{
.u_c_ZAKX28.normal{
position:relative;
display:block;
width:100%;

}
}.ar-SA{
.u_c_EOAU29.normal{
position:relative;
display:flex;
height:1.89rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728630919068-19.jpeg);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_EOAU29.normal.cur{
filter:brightness(1.4);

}
}.ar-SA{
.u_c_3GCD30.normal{
position:relative;
font-size:0.37rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}
</style>
